import { useQuery } from '@tanstack/react-query'
import { apiClient } from '@/api/client'
import type { components } from '@/api/types'

export const AUDIT_OVERVIEW_QUERY_KEY = ['admin', 'audit-overview'] as const

/** A live security posture payload — backend OpenAPI type (DEC-ADMIN-012). */
export type AuditOverview = components['schemas']['AuditOverview']

/**
 * `GET /admin/audit/overview` (DEC-ADMIN-012).
 *
 * Read-only live security posture (HSTS, 2FA, retention, rate-limits,
 * maintenance, DÁP, Sentry). Every value is read by the backend from the
 * running config/DB — the admin page just renders it.
 */
export function useAuditOverview() {
  return useQuery({
    queryKey: AUDIT_OVERVIEW_QUERY_KEY,
    queryFn: async (): Promise<AuditOverview | null> => {
      const { data, error } = await apiClient.GET('/admin/audit/overview')
      if (error) throw error
      return data?.data ?? null
    },
  })
}
